import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/wrapped/bgpage06.jpg")